import {
    BANKER_LOGIN,
    CONFIRM_BANKER_EMAIL_OTP,
    GET_BANKER_INFORMATION_BY_BANKER_ID,
    SEND_Banker_VERIFY_EMAIL_OTP,
    UPDATE_BANKER_DATA,
    ADD_UPDATE_SPONSER,
    GET_SPONSER_DATA_BY_ID,
    GET_SPONSER_DATA_BY_BANKER_EMAIL_ID,
    DELETE_SPONSER_BY_ID,
    RESEND_EMAIL_WITH_LINK_AND_PASS,
    GET_SPONSER_LIST_BY_BANKER_ID,
    DELETE_SPONSER_APPLICANT_BY_ID,
    FORGOT_BANKER_PASSWORD,
    GET_BANKER_DASHBOARD_SUMMARY_BY_BANKER_ID,
    GET_BANKER_DASHBOARD_SUMMARY_BY_UNDERWRITER_BANKER_ID,
    ADD_OR_UPDATE_BANKER_METRICS_DATA,
    GET_BANKER_METRICS_BY_BANKER_ID,
    GET_BANKER_LOAN_APPLICATION_SUMMARY,
    GET_ALL_LOAN_APPLICATION_LIST_BY_BANKER_ID,
    GET_ALL_LOAN_APPLICATION_LIST_BY_UNDERWRITER_BANKER_ID,
    GET_APPLICATION_LIST_BY_SPONSER_ID,
    GET_BANKER_REVISIT_APPLICATION_LIST_BY_BANKER_ID,
    ADD_OR_UPDATE_RISK_FREE_LOAN_DATA,
    GET_RISK_FREE_LOAN_BY_APPLICANT_ID,
    ADD_APPLICATION_REVIEW_COMMENT,
    GET_APPLICATION_REVIEW_COMMENT_FOR_BANKER,
    IS_RECOMADATION_LIMIT_BEYOND_THE_LIMIT_FOR_UNDERWRITER_BANKER,
    CHANGE_BANKER_PASSWORD,
    UPDATE_APPLICANT_STATUS,
    RESEND_SPONSER_APPLICANT_EMAIL_OTP,
    DELETE_SPONSER_APPLICANTS_DATA,
    GET_COMPLIANCE_DASHBOARD_SUMMARY_BY_COMPLIANCE_ID,
    GET_ALL_LOAN_APPLICATION_LIST_BY_COMPLIANCE_ID,
    SAVE_SPONSER_APPLICANT,
    GET_USER_MANAGEMENT_DATA,
    INSTITUTION_LOGIN,
    GET_ALL_USERS_DATA_FOR_LOAN_PROGRAM,
    ADD_UPDATE_BANKER_USER_DATA,
    CONFIRM_EMAIL_OTP_FOR_BANKER_ROLES,
    GET_ALL_INSTITUTION_USER_LIST_BY_BANK_ADMIN_ID,
    DELETE_BANKER_USER_BY_ID,
    RESEND_EMAIL_WITH_LINK_AND_PASSCODE_FOR_BANKER_USER,
    GET_ALL_FIRM_MASTER,
    SEARCH_FIRM_MASTER,
    GET_FIRM_CREDIT_FACILITY_LIST_BY_BANKER_ID,
    GET_SPONSER_FACILITY_LIST_BY_FIRM_ID,
    GET_FIRMS_LIST_FOR_SENIOR_PRIVATE_BANKER,
    GET_EXISTING_FIRM_ADMIN_BY_FIRM_ID,
} from "../constants/constants";
import { instance } from "./apiRequest";

let _BankerService = {
    async sendVerifyEmailOTP(obj) {
        return await instance.post(SEND_Banker_VERIFY_EMAIL_OTP, obj);
    },
    async confirmEmailOTP(obj) {
        return await instance.post(CONFIRM_BANKER_EMAIL_OTP, obj);
    },
    async updateBankerData(reqObj) {
        return await instance.post(UPDATE_BANKER_DATA, reqObj);
    },
    async bankerLogin(obj) {
        return await instance.post(BANKER_LOGIN, obj);
    },
    async institutionLogin(obj) {
        return await instance.post(INSTITUTION_LOGIN, obj);
    },
    async getBankerInformationByBankerId(bankerId) {
        return await instance.post(GET_BANKER_INFORMATION_BY_BANKER_ID, { bankerId: bankerId });
    },
    async getUserManagementData(emailId, roleId, bankAdminId) {
        return await instance.post(GET_USER_MANAGEMENT_DATA, { email: emailId, roleId: roleId, bankAdminId: bankAdminId });
    },
    async addUpdateSponser(obj) {
        return await instance.post(ADD_UPDATE_SPONSER, obj);
    },
    async getAllFirmMaster() {
        return await instance.post(GET_ALL_FIRM_MASTER, {});
    },
    async searchFirmMaster(searchTerm) {
        return await instance.post(SEARCH_FIRM_MASTER, { SearchTerm: searchTerm });
    },
    async saveSponserApplicant(obj) {
        return await instance.post(SAVE_SPONSER_APPLICANT, obj);
    },
    async getSponserDataBySponserId(sponserId) {
        return await instance.post(GET_SPONSER_DATA_BY_ID, { sponserId: sponserId });
    },
    async getSponserDataByBankerEmailId(bankerEmailId) {
        return await instance.post(GET_SPONSER_DATA_BY_BANKER_EMAIL_ID, { email: bankerEmailId });
    },
    async deleteSponserBySponserId(sponserId) {
        return await instance.post(DELETE_SPONSER_BY_ID, { sponserId: sponserId });
    },
    async resendEmailWithLinkAndPasscode(emailId) {
        return await instance.post(RESEND_EMAIL_WITH_LINK_AND_PASS, { email: emailId });
    },
    async getSponserListByBankerId(bankerId, startDate = null, endDate = null, pageIndex = 1, pageSize = 10, searchTerm = null, sortBy = "Id", sortAsc = true) {
        let body = { id: bankerId, pageIndex: pageIndex, pageSize: pageSize, sortBy: sortBy, sortAsc: sortAsc };
        if (startDate) body.startDate = startDate;
        if (endDate) body.endDate = endDate;
        if (searchTerm) body.searchTerm = searchTerm;
        return await instance.post(GET_SPONSER_LIST_BY_BANKER_ID, body);
    },
    async getFirmCreditFacilityListByBankerId(bankerId, startDate = null, endDate = null, pageIndex = 1, pageSize = 10, searchTerm = null, sortBy = "CompanyName", sortAsc = true) {
        let body = { id: bankerId, pageIndex: pageIndex, pageSize: pageSize, sortBy: sortBy, sortAsc: sortAsc };
        if (startDate) body.startDate = startDate;
        if (endDate) body.endDate = endDate;
        if (searchTerm) body.searchTerm = searchTerm;
        return await instance.post(GET_FIRM_CREDIT_FACILITY_LIST_BY_BANKER_ID, body);
    },
    async getSponserFacilityListByFirmId(firmId, bankerId) {
        return await instance.post(GET_SPONSER_FACILITY_LIST_BY_FIRM_ID, { firmId: firmId, bankerId: bankerId });
    },
    async getFirmsListForSeniorPrivateBanker(bankerId) {
        return await instance.post(GET_FIRMS_LIST_FOR_SENIOR_PRIVATE_BANKER, { bankerId: bankerId });
    },
    async getExistingFirmAdminByFirmId(firmId) {
        return await instance.post(GET_EXISTING_FIRM_ADMIN_BY_FIRM_ID, { firmId: firmId });
    },
    async deleteSponserApplicantById(applicantId) {
        return await instance.post(DELETE_SPONSER_APPLICANT_BY_ID, { id: applicantId });
    },
    async forgotBankerPassword(reqObj) {
        return await instance.post(FORGOT_BANKER_PASSWORD, reqObj);
    },
    async getBankerDashboardSummaryByBankerId(bankerId, isBanker) {
        return await instance.post(GET_BANKER_DASHBOARD_SUMMARY_BY_BANKER_ID, { bankerId: bankerId, isBanker: isBanker });
    },
    async getBankerDashboardSummaryByUnderwriterBankerId(bankerId) {
        return await instance.post(GET_BANKER_DASHBOARD_SUMMARY_BY_UNDERWRITER_BANKER_ID, { bankerId: bankerId });
    },
    async addOrUpdateBankerMetricsData(reqObj) {
        return await instance.post(ADD_OR_UPDATE_BANKER_METRICS_DATA, reqObj);
    },
    async getBankerMetricsByBankerIDAndSponserId(bankerId, sponserId) {
        return await instance.post(GET_BANKER_METRICS_BY_BANKER_ID, { bankerId: bankerId, sponserId: sponserId });
    },
    async getBankerLoanApplicationMonthlySummaryByBankerId(bankerId) {
        return await instance.post(GET_BANKER_LOAN_APPLICATION_SUMMARY, { bankerId: bankerId });
    },
    // async getAllLoanApplicationListByBankerId({ bankerId, startDate = "", endDate = "", pageIndex = 1, pageSize = 10, searchTerm = "", sortBy = "id", sortAsc = false }) {
    //     let url = `${GET_ALL_LOAN_APPLICATION_LIST_BY_BANKER_ID}?bankerId=${bankerId}&startDate=${startDate}&endDate=${endDate}&pageIndex=${pageIndex}&pageSize=${pageSize}&searchTerm=${searchTerm}&sortBy=${sortBy}&sortAsc=${sortAsc}`;
    //     return await instance.get(url);
    // },

    async getAllLoanApplicationListByBankerId({
        bankerId, isBanker, ByAppStatus, startDate, endDate, pageIndex, pageSize, searchTerm, sortBy, sortAsc
    }) {
        let appStatus = ByAppStatus ? ByAppStatus : 0;

        let body = {
            bankerId: bankerId,
            isBanker: isBanker,
            pageIndex: pageIndex,
            pageSize: pageSize,
            byAppStatus: appStatus,
        };

        if (searchTerm && searchTerm != "") {
            body.searchTerm = searchTerm;
        }
        if (startDate && startDate != "" && endDate && endDate != "") {
            body.startDate = startDate;
            body.endDate = endDate;
        }
        if (sortBy && sortBy != "") {
            let sortBytext = (sortBy == "newest" || sortBy == "oldest") ? "createddate" : "app_det_loanamount";
            body.sortBy = sortBytext;
        }
        if (sortAsc && sortAsc != "") {
            let sortBytext = (sortBy == "oldest" || sortBy == "high") ? false : true;
            body.sortAsc = sortBytext;
        }
        return await instance.post(GET_ALL_LOAN_APPLICATION_LIST_BY_BANKER_ID, body);
    },

    async getAllLoanApplicationListByUnderwriterBankerId({
        bankerId, ByAppStatus, startDate, endDate, pageIndex, pageSize, searchTerm, sortBy, sortAsc
    }) {
        let appStatus = ByAppStatus ? ByAppStatus : 0;

        let body = {
            id: bankerId,
            pageIndex: pageIndex,
            pageSize: pageSize,
            byAppStatus: appStatus,
        };

        if (searchTerm && searchTerm != "") {
            body.searchTerm = searchTerm;
        }
        if (startDate && startDate != "" && endDate && endDate != "") {
            body.startDate = startDate;
            body.endDate = endDate;
        }
        if (sortBy && sortBy != "") {
            let sortBytext = (sortBy == "newest" || sortBy == "oldest") ? "createddate" : "app_det_loanamount";
            body.sortBy = sortBytext;
        }
        if (sortAsc && sortAsc != "") {
            let sortBytext = (sortBy == "oldest" || sortBy == "high") ? false : true;
            body.sortAsc = sortBytext;
        }
        return await instance.post(GET_ALL_LOAN_APPLICATION_LIST_BY_UNDERWRITER_BANKER_ID, body);
    },

    // async getApplicationListBySponserId(sponserId, pageIndex, pageSize, searchTerm, sortBy, sortAsc, startDate, endDate) {
    //     let url = GET_APPLICATION_LIST_BY_SPONSER_ID + "?sponserId=" + sponserId
    //     // + "&pageIndex=" + pageIndex +
    //     //     "&pageSize=" + pageSize + "&searchTerm=" + searchTerm + "&sortBy=" + sortBy + "&sortAsc=" + sortAsc +
    //     //     "&startDate=" + startDate + "&endDate=" + endDate;
    //     return await instance.get(url);
    // },

    async getApplicationListBySponserId({
        sponserId, ByAppStatus, startDate, endDate, pageIndex, pageSize, searchTerm, sortBy, sortAsc }) {
        let body = {
            id: sponserId,
            pageIndex: pageIndex,
            pageSize: pageSize,
            byAppStatus: ByAppStatus,
        };

        if (searchTerm && searchTerm != "") {
            body.searchTerm = searchTerm;
        }
        if (startDate && startDate != "" && endDate && endDate != "") {
            body.startDate = startDate;
            body.endDate = endDate;
        }
        if (sortBy && sortBy != "") {
            let sortBytext = (sortBy == "newest" || sortBy == "oldest") ? "createddate" : "app_det_loanamount";
            body.sortBy = sortBytext;
        }
        if (sortAsc && sortAsc != "") {
            let sortBytext = (sortBy == "oldest" || sortBy == "high") ? false : true;
            body.sortAsc = sortBytext;
        }
        return await instance.post(GET_APPLICATION_LIST_BY_SPONSER_ID, body);
    },

    async getBankerRevistApplicationListByBankerId({ bankerId, startDate = "", endDate = "", pageIndex = 1, pageSize = 10, searchTerm = "", sortBy = "id", sortAsc = false }) {
        return await instance.post(GET_BANKER_REVISIT_APPLICATION_LIST_BY_BANKER_ID, { id: bankerId, startDate: startDate, endDate: endDate, pageIndex: pageIndex, pageSize: pageSize, searchTerm: searchTerm, sortBy: sortBy, sortAsc: sortAsc });
    },
    async addOrUpdateRiskFreeLoanData(reqObj) {
        return await instance.post(ADD_OR_UPDATE_RISK_FREE_LOAN_DATA, reqObj);
    },
    async getRiskFreeLoanByApplicantId(applicationId) {
        return await instance.post(GET_RISK_FREE_LOAN_BY_APPLICANT_ID, { applicationId: applicationId });
    },
    async addApplicationReviewComment(reqObj) {
        return await instance.post(ADD_APPLICATION_REVIEW_COMMENT, reqObj);
    },
    async isRecomadationLimitBeyondtheLimitForUnderwriterBanker(bankerId, applicationId) {
        return await instance.post(IS_RECOMADATION_LIMIT_BEYOND_THE_LIMIT_FOR_UNDERWRITER_BANKER, { bankerId: bankerId, applicationId: applicationId });
    },
    async getApplicationReviewCommentForBanker(applicationId, bankerId) {
        return await instance.post(GET_APPLICATION_REVIEW_COMMENT_FOR_BANKER, { applicationId: applicationId, bankerId: bankerId });
    },

    async ChangeBankerPassword(reqObj) {
        return await instance.post(CHANGE_BANKER_PASSWORD, reqObj);
    },
    async updateApplicantStatus(reqObj) {
        return await instance.post(UPDATE_APPLICANT_STATUS, reqObj);
    },
    async resendApplicantEmailOTP(reqObj) {
        return await instance.post(RESEND_SPONSER_APPLICANT_EMAIL_OTP, reqObj);
    },
    async deleteSponserApplicantsData(reqObj) {
        return await instance.post(DELETE_SPONSER_APPLICANTS_DATA, reqObj);
    },


    async getComplianceDashboardSummaryByComplianceId(bankerId) {
        return await instance.post(GET_COMPLIANCE_DASHBOARD_SUMMARY_BY_COMPLIANCE_ID, { bankerId: bankerId });
    },

    async getAllLoanApplicationListByComplianceId({
        bankerId,
        ByAppStatus,
        startDate,
        endDate,
        pageIndex,
        pageSize,
        searchTerm,
        sortBy,
        sortAsc,
    }) {
        let appStatus = ByAppStatus ? ByAppStatus : 0;

        let body = {
            id: bankerId,
            pageIndex: pageIndex,
            pageSize: pageSize,
            byAppStatus: appStatus,
        };

        if (searchTerm && searchTerm !== "") {
            body.searchTerm = searchTerm;
        }

        if (startDate && endDate) {
            body.startDate = startDate;
            body.endDate = endDate;
        }

        if (sortBy && sortBy !== "") {
            const sortByText =
                sortBy === "newest" || sortBy === "oldest"
                    ? "createddate"
                    : "app_det_loanamount";

            body.sortBy = sortByText;
        }

        if (sortAsc !== undefined && sortAsc !== "") {
            const sortAscValue =
                sortBy === "oldest" || sortBy === "high"
                    ? false
                    : true;

            body.sortAsc = sortAscValue;
        }

        return await instance.post(GET_ALL_LOAN_APPLICATION_LIST_BY_COMPLIANCE_ID, body);
    },
    async getAllUsersDataForLoanProgram(isEditMode = true) {
        return await instance.post(GET_ALL_USERS_DATA_FOR_LOAN_PROGRAM, { isEditMode: isEditMode });
    },

    // Multi-role Banker + BankerRoles user creation (replaces UserManagement for new users created this way)
    async addUpdateBankerUserData(reqObj) {
        return await instance.post(ADD_UPDATE_BANKER_USER_DATA, reqObj);
    },
    async confirmEmailOTPForBankerRoles(reqObj) {
        return await instance.post(CONFIRM_EMAIL_OTP_FOR_BANKER_ROLES, reqObj);
    },
    async getAllInstitutionUsersByBankAdminId({ BankAdminId, startDate = "", endDate = "", pageIndex = 1, pageSize = 10, searchTerm = "", sortBy = "id", sortAsc = false }) {
        return await instance.post(GET_ALL_INSTITUTION_USER_LIST_BY_BANK_ADMIN_ID, { bankAdminId: BankAdminId, pageIndex: pageIndex, pageSize: pageSize, searchTerm: searchTerm, sortBy: sortBy, sortAsc: sortAsc, startDate: startDate, endDate: endDate });
    },
    async deleteBankerUserById(id) {
        return await instance.post(DELETE_BANKER_USER_BY_ID, { id: id });
    },
    async reSendEmailWithLinkAndPasscodeForBankerUser(email) {
        return await instance.post(RESEND_EMAIL_WITH_LINK_AND_PASSCODE_FOR_BANKER_USER, { email: email });
    },
}
export default _BankerService;